import { ROUTES } from './PathRoutes';

// Mapeamento centralizado de permissões
export const PERMISSIONS = {
    // FAQ
    FAQ_MANAGE: 'faq.manage_faq',

    // Usuários
    USER_MANAGE: 'user.manage_user',

    // Produtos
    PRODUCT_MANAGE: 'product.manage_product',

    // Blog
    BLOG_MANAGE: 'news.manage_blog',

    // Staff (Membros da Equipe)
    STAFF_MANAGE: 'authentication.manage_staff',

    // Ecommerce
    ECOMMERCE_MANAGE: 'ecommerce.manage_ecommerce',

    // Prescrições
    PRESCRIPTION_MANAGE: 'ecommerce.manage_prescriptions',

    // Clientes
    CLIENT_MANAGE: 'authentication.manage_clients',

    // Site Settings (Configurações do Site)
    SITE_SETTINGS_MANAGE: 'site_config.manage_site_settings',

    // Relatórios
    REPORTS_VIEW: 'reports.view_reports',

    // Logs de Auditoria
    AUDIT_LOG_VIEW: 'audit_log.view_audit_log',
};

// Helper para obter todas as permissões (usado quando is_admin = true)
export const getAllPermissions = () => Object.values(PERMISSIONS);

// Mapeamento de rotas para permissões
export const ROUTE_PERMISSIONS = {
    [ROUTES.ADMIN_FAQ_LIST]: PERMISSIONS.FAQ_MANAGE,
    [ROUTES.ADMIN_USUARIOS]: PERMISSIONS.USER_MANAGE,
    [ROUTES.ADMIN_PRODUTOS]: PERMISSIONS.PRODUCT_MANAGE,
    [ROUTES.ADMIN_BLOG_LIST]: PERMISSIONS.BLOG_MANAGE,
    [ROUTES.ADMIN_STAFF_LIST]: PERMISSIONS.STAFF_MANAGE,
    [ROUTES.ADMIN_ECOMMERCE_CATEGORY_LIST]: PERMISSIONS.ECOMMERCE_MANAGE,
    [ROUTES.ADMIN_ECOMMERCE_PRODUCT_LIST]: PERMISSIONS.ECOMMERCE_MANAGE,
    [ROUTES.ADMIN_ECOMMERCE_SHIPPING_LIST]: PERMISSIONS.ECOMMERCE_MANAGE,
    [ROUTES.ADMIN_ECOMMERCE_PRESCRIPTION_LIST]: PERMISSIONS.PRESCRIPTION_MANAGE,
    [ROUTES.ADMIN_ECOMMERCE_ORDER_LIST]: PERMISSIONS.ECOMMERCE_MANAGE,
    [ROUTES.ADMIN_CLIENT_LIST]: PERMISSIONS.CLIENT_MANAGE,
    [ROUTES.ADMIN_SITE_SETTINGS]: PERMISSIONS.SITE_SETTINGS_MANAGE,
    [ROUTES.ADMIN_REPORTS_PATIENTS]: PERMISSIONS.REPORTS_VIEW,
    [ROUTES.ADMIN_REPORTS_ECOMMERCE]: PERMISSIONS.REPORTS_VIEW,
    [ROUTES.ADMIN_REPORTS_GENERATED]: PERMISSIONS.REPORTS_VIEW,
    [ROUTES.ADMIN_AUDIT_LOG_LIST]: PERMISSIONS.AUDIT_LOG_VIEW,
};

// Helper para verificar se uma rota requer permissão
export const getRoutePermission = (pathname) => {
    // Verifica match exato primeiro
    if (ROUTE_PERMISSIONS[pathname]) {
        return ROUTE_PERMISSIONS[pathname];
    }

    // Verifica se a rota começa com algum path mapeado
    for (const [route, permission] of Object.entries(ROUTE_PERMISSIONS)) {
        if (pathname.startsWith(route)) {
            return permission;
        }
    }

    return null; // Rota não requer permissão específica
};